var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dsf-drag-view ds-control ds-no-padding" }, [
    _vm.isDesign
      ? _c(
          "div",
          { staticClass: "dsf-drag-view-tools" },
          _vm._l(_vm.layoutButs, function (item) {
            return _c(
              "div",
              {
                key: item,
                staticClass: "dsf-drag-view-tools-item",
                class: { "active-btn": _vm.screenRatio === item },
                on: {
                  click: function ($event) {
                    _vm.screenRatio = item
                  },
                },
              },
              [_vm._v(_vm._s(item))]
            )
          }),
          0
        )
      : _vm._e(),
    _c(
      "div",
      {
        ref: "container",
        staticClass: "dsf-layout-container",
        class: { "dsf-layout-container__design": _vm.isDesign },
      },
      [
        _vm.isLoaded
          ? _vm._l(_vm.layout, function (item, index) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.handleShow(index),
                      expression: "handleShow(index)",
                    },
                  ],
                  key: index,
                  staticClass: "dsf-layout-grid",
                  style: { "z-index": item.zIndex },
                },
                _vm._l(item.layout[_vm.screenRatio], function (it) {
                  return _c(
                    "div",
                    {
                      key: it.i,
                      staticClass: "dsf-layout-grid-item",
                      style: _vm.setGridItemStyle(it, item),
                      attrs: { "slot-name": _vm.getSlotName(it, index) },
                    },
                    [_vm._t(_vm.getSlotName(it, index))],
                    2
                  )
                }),
                0
              )
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }